export const US = 'US';
export const CANADA = 'Canada';
export const US_AND_CANADA = 'US & Canada';
export const VALID_REGIONS = [US, CANADA, US_AND_CANADA];
